 class CartVat extends HTMLElement {
            constructor() {
                super();
                          
            }

   connectedCallback() {
         this.checkbox = this.querySelector('#invoiceCheckbox');
         this.form = this.querySelector('#invoice-form');

                this.checkbox.addEventListener('change', () => {
                    if (this.checkbox.checked) {
                        this.show();
                    } else {
                        this.hide();
                    }
                });
   }

 

            show() {
                this.form.classList.remove('hidden');
            }

            hide() {
                this.form.classList.add('hidden');
            }
        }

        customElements.define('cart-vat', CartVat);

console.log("test")